import { apiUrl } from "utils/urls";

import axios from "axios";

export const postPaymentBillingKey = async (body) => {
    const { data } = await axios.post(apiUrl("paymentBillingKey"), body);
    return data;
};

export const getPaymentBillingKeyList = async (params) => {
    const { data } = await axios.get(apiUrl("paymentBillingKey"), {
        params: params,
    });
    return data;
};

export const deletePaymentBillingKey = async (id) => {
    const { data } = await axios.delete(apiUrl("paymentBillingKey") + "/" + id);
    return data;
};

export const getPaymentPlan = async (params) => {
    const { data } = await axios.get(apiUrl("paymentPlan"), { params: params });
    return data;
};

export const getPaymentCoupon = async (params) => {
    const { data } = await axios.get(apiUrl("paymentCoupon"), { params: params });
    return data;
};

export const registerPaymentCoupon = async (body) => {
    const { data } = await axios.post(apiUrl("paymentCouponRegister"), body);
    return data;
};

export const getPaymentDiscountPolicy = async (params) => {
    const { data } = await axios.get(apiUrl("paymentDiscountPolicy"), { params: params });
    return data;
};
